import React from "react";
import { compose, withProps, withState, branch } from "recompose";
import EnhanceCategory from "./EnhanceCategory";
import CategoryQuery from "./CategoryQuery.gql";
import Loadable from "theme/components/helpers/Loadable";
import withTrackPage from "theme/modules/Analytics/withTrackPage";
import EmptyCategory from "theme/modules/Category/EmptyCategory";
import withFilterableCategoryTracking from "theme/modules/Category/withFilterableCategoryTracking";
import PaginatedPage from "theme/modules/Layer/PaginatedPage";
import PaginatedPageHeader from "theme/modules/Layer/PaginatedPage/PaginatedPageHeader";
import ProductsGrid from "theme/components/organisms/GridCards/ProductsGrid";
import Sorting from "theme/components/molecules/Sorting";
import Limit from "theme/components/molecules/Limit";
import { withCookies } from "react-cookie";
import { graphql } from "react-apollo";
import ConfigurationQuery from "./ConfigurationQuery.gql";
import withGenderFilter from "theme/components/helpers/withGenderFilter";
import qs from "web/core/utils/queryString";
import { withApollo } from "react-apollo";
import { SpinnerFullPage } from "theme/components/atoms/Spinner";
import { trackGlobalPage } from "../../components/helpers/AnalyticsV4/TrackAnlyticsV4";

const Category = (props) => {
  return (
    <PaginatedPage
      meta_title={props.category.meta_title}
      meta_description={props.category.meta_description}
      categoryDefaultOgDescription={
        props.config &&
        props.config.storeConfiguration &&
        props.config.storeConfiguration.categoryDefaultOgDescription
      }
      layer={props.category.layer}
      emptyPage={EmptyCategory}
      display_mode={props.category.display_mode}
      cms_block={props.category.cms_block}
      length={props.length}
      itemsCount={props.productsCount}
      location={props.location}
      page={props.page}
      activeFilters={props.activeFilters}
      hasFilters={props.hasFilters}
      loading={props.loading}
      isLayerActive={props.isLayerActive}
      toggleFilters={props.toggleFilters}
      gender_content_men_slippers={props.category.gender_content_men_slippers}
      gender_content_men_socks={props.category.gender_content_men_socks}
      gender_content_women_slippers={
        props.category.gender_content_women_slippers
      }
      gender_content_women_socks={props.category.gender_content_women_socks}
      gender_content_women_tights={props.category.gender_content_women_tights}
      gender_content_kids_slippers={props.category.gender_content_kids_slippers}
      gender_content_kids_socks={props.category.gender_content_kids_socks}
      gender_content_kids_tights={props.category.gender_content_kids_tights}
      renderHeader={() => (
        <PaginatedPageHeader
          breadcrumb={props.category.breadcrumb}
          name={props.category.name}
          image={props.category.image}
          hideCategoryName={props.category.hide_category_name}
          imageMedia={props.category.media_image}
          description={props.category.description}
          isLayerActive={props.isLayerActive}
          toggleFilters={props.toggleFilters}
          buckets={props.category?.layer?.dynamicFacets[0]?.buckets}
        />
      )}
      renderSorting={() => (
        <Sorting
          isLayerActive={props.isLayerActive}
          toggleFilters={props.toggleFilters}
        />
      )}
      renderLimit={() => (
        <Limit
          isLayerActive={props.isLayerActive}
          toggleFilters={props.toggleFilters}
        />
      )}
    >
      <ProductsGrid
        products={props.category.layer.products}
        loading={props.loading}
        breadcrumb={props.category.breadcrumb}
        categoryName={props.category.name}
        location={props.location}
      />
    </PaginatedPage>
  );
};

export default compose(
  withApollo,
  withGenderFilter(),
  withState("reloadSSR", "setReloadSSR", false),
  withProps((props) => {
    const params = qs.parse(props.location.search);
    if (!props.currentGender && params[props.genderFilterName]) {
      props.setReloadSSR(true);
      // Force set gender on front redirection
      // @see common/server/modules/collegien/express/index.js
      props.setGender(null, params[props.genderFilterName], props.genders);
      setTimeout(() => {
        // Force disable Loader after 1second in case of reset store make error
        props.setReloadSSR(false);
      }, 1000);
    }
  }),
  branch(
    (props) => !props.reloadSSR,
    (BaseComponent) => BaseComponent,
    () => () => <SpinnerFullPage />
  ),
  EnhanceCategory({ CategoryQuery }),
  withTrackPage("Category"),
  trackGlobalPage("list"),
  Loadable((props) => !!props.category, true),
  withFilterableCategoryTracking(),
  withCookies,
  graphql(ConfigurationQuery, {
    name: "config",
  }),
  withProps((props) => {
    if (
      !props.loading &&
      props.cookies &&
      props.config &&
      props.config.storeConfiguration &&
      props.config.storeConfiguration.privatesalesGeneralEnable === "1" &&
      parseInt(props.category.id) ===
        parseInt(props.config.storeConfiguration.privatesalesGeneralCategory) &&
      props.cookies.get("access_private_sales") !== "true"
    ) {
      props.cookies.set("access_private_sales", "true", { path: "/" });
    }
    return false;
  }),
  withProps((props) => {
    if (typeof window !== "undefined" && localStorage) {
      localStorage.setItem(
        "last_category_visited",
        window.location.pathname + window.location.search
      );
    }
    return false;
  })
)(Category);
